import React from 'react';
import { cabecera } from '../utils/cabecera.js';

const d = new Date();

const Footer = props => (
	<div style={{ width: '190px', margin: '0 auto', paddingTop: '2.2em' }}>
		<div className="footer">
			<a
				target="_blank"
				href={cabecera[props.joly].u}
				src={`./manchetas/${props.joly}.svg`}
				alt={`${cabecera[props.joly].n}`}
			>
				<img
					src={`./manchetas/${props.joly}.svg`}
					alt={`${cabecera[props.joly].n}`}
				/>
			</a>
			<p style={{ fontWeight: '700', paddingBottom: '2em' }}>
				Grupo Joly {' '}
				<span style={{ fontWeight: 300 }}>© {d.getFullYear()}</span>
			</p>
		</div>
	</div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js